import React, { useState, useEffect } from "react";
import {
  Grid,
  Typography,
  Box,
  Button,
  TextField,
  useMediaQuery,
  Card,
  CardContent,
} from "@mui/material";
import { ItemCard } from "./Component/ItemCard";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { Drop_Id_Set } from "./SliceSegregation";
import {
  fAlertToast,
  fcheck_null_undefine_replace_empty,
  fcovertToNumber,
} from "../../Utility/Utilitys";
import BreadCrumbs from "./Component/BreadCrumbs";
import { Detail } from "./Component/Detail";
import {
  CmpInputField,
  CmpSelectBox,
  CmpSelectField,
  CmpStatusIconV4,
  CmpTextField,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import { SegregationRo, vRdxUserInfo } from "../../Redux/roStore";
import {
  Segregation_DropID_GetRow,
  WMPKLSTLI_Delete_GetRow,
  WMPKLSTLI_GetRow,
  WMPKLSTLI_Update_GetRow,
} from "../../Server/ApiV2";
import { fExecuteAPI } from "../../Server/Apis";
const initialData = [
  // { LI_SrNo: 1, LI_BaseQty: "1" },
];
const SegregrationDetail = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const vMediaQuery = useMediaQuery("(max-width:650px)");
  const [data, setData] = useState([]);
  const [Unit, setUnit] = useState([]);
  const [VirtualBinList, setVirtualBinList] = useState([]);
  const { Head: vRdxHead, Item: vRdxItem } = useSelector(
    (state) => state.SliceSegregation.value
  );

  const bufferInit = {
    LI_SrNo: 0,
    LI_BaseQty: "",
    LI_Qty: "",
    LI_Unit: "",
    B_UnitName: "",
    B_PackQty: 0,
    B_Packing: 0,
    L_DropID: vRdxItem.L_DropID,
    VirtualBin: "",
  };

  const [sBufferObj, setBufferObj] = useState(bufferInit);
  const errorInit = {
    LI_SrNo: 0,
    LI_BaseQty: "",
    LI_Qty: "",
    LI_Unit: "",
    B_UnitName: "",
    B_PackQty: 0,
    B_Packing: 0,
    L_DropID: "",
    VirtualBin: "",
  };
  const [Error, setError] = useState(errorInit);

  const fNew = async () => {
    setError(errorInit);
    setBufferObj(bufferInit);
    await handleLoad();
    await handleUnit();
    await getVirtualBinList();
  };

  const getVirtualBinList = async () => {
    const { Head } = SegregationRo();
    const { Item } = SegregationRo();
    const Obj = {
      VocTyp: Head.A_VocTyp,
      VocNo: Head.A_VocNo,
      ItmCd: Item.ItmCd,
      UnitId: Item.UnitId,
    };
    let resp = await Segregation_DropID_GetRow(
      fcheck_null_undefine_replace_empty(Obj)
    );
    if (resp?.status === 200) {
      setVirtualBinList(resp?.data?.ResultSet);
    }
  };

  const fDelete = async () => {
    const { Head } = SegregationRo();
    const { Item } = SegregationRo();
    const Obj = {
      // v_UserCd: vRdxUserInfoObj?.UserID,
      LI_VocTyp: Head.A_VocTyp,
      LI_VocNo: Head.A_VocNo,
      LI_Loc: Item.L_Loc,
      LI_ItmCd: Item.ItmCd,
      LI_SrNo: sBufferObj.LI_SrNo,
    };
    let resp = await WMPKLSTLI_Delete_GetRow(
      fcheck_null_undefine_replace_empty(Obj)
    );
    if (resp?.status === 200) {
      fAlertToast("SUCCESS", "Updated Successfully");
      fNew();
      document.getElementsByName("LI_Qty")[0]?.focus();
    }
  };
  const save = async () => {
    const { Head } = SegregationRo();
    const { Item } = SegregationRo();

    if (
      sBufferObj.LI_Qty == "" ||
      sBufferObj.LI_Qty == null ||
      sBufferObj.LI_Qty == 0
    ) {
      let error =
        sBufferObj.LI_Qty === ""
          ? "Quantity should not be empty"
          : "Quantity should not be zero";
      fAlertToast("FAILED", error);
      return;
    }
    //  if (
    //   (sBufferObj.L_DropID == "" ||
    //     sBufferObj.L_DropID == null ||
    //     sBufferObj.L_DropID == 0) &&
    //   vRdxItem?.A_SegregationMethod != 1
    // ) {
    //   let error =
    //     sBufferObj.L_DropID === ""
    //       ? "Drop ID quantity should not be empty"
    //       : "Drop ID quantity should not be zero";
    //   fAlertToast("FAILED", error);
    //   return;
    // } else if (
    //   (sBufferObj.VirtualBin == "" ||
    //     sBufferObj.VirtualBin == null ||
    //     sBufferObj.VirtualBin == undefined) &&
    //   vRdxItem?.A_SegregationMethod == 1
    // ) {
    //   let error =
    //     sBufferObj.VirtualBin === ""
    //       ? "Virtual Bin should not be empty"
    //       : "Virtual Bin should not be zero";
    //   fAlertToast("FAILED", error);
    //   return;
    // } else
    else if (
      sBufferObj.LI_Unit == "" ||
      sBufferObj.LI_Unit == null ||
      sBufferObj.LI_Unit == 0
    ) {
      let error =
        sBufferObj.LI_Unit === ""
          ? "Unit should not be empty"
          : "Unit should not be zero";
      fAlertToast("FAILED", error);
      return;
    } else {
      const Obj = {
        // v_UserCd: vRdxUserInfoObj?.UserID,
        LI_VocTyp: Head.A_VocTyp,
        LI_VocNo: Head.A_VocNo,
        LI_Loc: Item.L_Loc,
        LI_ItmCd: Item.ItmCd,
        LI_SrNo: Number(sBufferObj.LI_SrNo),
        LI_Qty: parseFloat(sBufferObj.LI_Qty),
        LI_Unit: sBufferObj.LI_Unit,
        // LI_BaseQty: sBufferObj.LI_BaseQty,
        LI_DropID: "",
        //   vRdxItem?.A_SegregationMethod == 1
        //     ? sBufferObj.VirtualBin
        //     : sBufferObj.L_DropID,
      };
      let resp = await WMPKLSTLI_Update_GetRow(
        fcheck_null_undefine_replace_empty(Obj)
      );
      if (resp?.status === 200) {
        fAlertToast("SUCCESS", "Updated Successfully");
        navigate("/segregationItemScan");
        if (vRdxItem.L_DropID == "") {
          dispatch(Drop_Id_Set(sBufferObj.L_DropID));
        }

        fNew();
        document.getElementsByName("LI_Qty")[0]?.focus();
      }
    }
  };
  const handleLoad = async () => {
    const { Head } = SegregationRo();
    const { Item } = SegregationRo();
    const Obj = {
      // v_UserCd: vRdxUserInfoObj?.UserID,
      LI_VocTyp: Head.A_VocTyp,
      LI_VocNo: Head.A_VocNo,
      LI_Loc: Item.L_Loc,
      LI_ItmCd: Item.ItmCd,
    };

    let resp = await WMPKLSTLI_GetRow(fcheck_null_undefine_replace_empty(Obj));
    if (resp?.status === 200 && resp?.data?.ResultSet.length > 0) {
      let respData = resp?.data?.ResultSet;
      setData(respData);
      if (vRdxItem.A_SegregationMethod == 1) {
        setBufferObj((obj) => ({
          ...obj,
          VirtualBin:
            vRdxItem.A_SegregationMethod == 1 ? vRdxItem.L_Loc || "" : "",
          L_DropID:
            vRdxItem.A_SegregationMethod != 1 ? vRdxItem.L_DropID || "" : "",
        }));
      }
      document.getElementsByName("LI_Qty")[0]?.focus();
    } else {
      setData(initialData);
    }
  };
  const handleUnit = async () => {
    //API Unit GETITEMUNITSINBOUND_GETROW
    const { Item } = SegregationRo();
    let itemUnitobj = {
      itemCd: Item?.ItmCd,
    };
    let FinalObj = fcheck_null_undefine_replace_empty(itemUnitobj);

    const UnitInfo = await fExecuteAPI("GETITEMUNITS_GETROW", FinalObj);
    if (UnitInfo?.Type?.toUpperCase() === "SUCCESS") {
      if (UnitInfo.ResultSet.length > 0) {
        setUnit(UnitInfo.ResultSet);
        let vItemUnitSet = UnitInfo?.ResultSet?.find((obj) => {
          return obj.Unit === Item?.UnitId;
        });
        if (!!vItemUnitSet) {
          setBufferObj((obj) => ({
            ...obj,
            LI_Unit: vItemUnitSet.Unit,
            B_UnitName: vItemUnitSet.Name1,
            B_PackQty: vItemUnitSet.PackQty,
            B_Packing: vItemUnitSet.PackDesc,
          }));
        } else {
          setBufferObj((obj) => ({
            ...obj,
            LI_Unit: UnitInfo.ResultSet[0].Unit,
            B_UnitName: UnitInfo.ResultSet[0].Name1,
            B_PackQty: UnitInfo.ResultSet[0].PackQty,
            B_Packing: UnitInfo.ResultSet[0].PackDesc,
          }));
        }

        return UnitInfo.ResultSet;
      } else {
        return [];
      }
    } else {
      fAlertToast(
        "FAILED",
        UnitInfo.Type.response.data.message
          ? UnitInfo.Type.response.data.message
          : "Error in UnitArr"
      );
      return [];
    }
  };

  useEffect(() => {
    console.log(vRdxItem.L_DropID);
    handleLoad();
    handleUnit();
    getVirtualBinList();
  }, []);

  const fOnRowClick = async (e) => {
    if (Unit.length > 0) {
      let vItemUnitSet = Unit.find((obj) => {
        return obj.Unit === e.row.LI_Unit || "";
      });
      if (!!vItemUnitSet) {
        setBufferObj((obj) => ({
          ...obj,
          LI_Unit: vItemUnitSet.Unit,
          B_UnitName: vItemUnitSet.Name1,
          B_PackQty: vItemUnitSet.PackQty,
          B_Packing: vItemUnitSet.PackDesc,
        }));
      } else {
        setBufferObj((obj) => ({
          ...obj,
          B_Unit: Unit[0].Unit,
          B_UnitName: Unit[0].Name1,
          B_PackQty: Unit[0].PackQty,
          B_Packing: Unit[0].PackDesc,
        }));
      }
      setBufferObj((obj) => ({
        ...obj,
        LI_SrNo: e.row.LI_SrNo,
        LI_Qty: e.row.LI_Qty || 0,
        VirtualBin:
          vRdxItem.A_SegregationMethod == 1 ? e.row.L_DropID || "" : "",
        L_DropID: vRdxItem.A_SegregationMethod != 1 ? e.row.L_DropID || "" : "",
      }));
    }
  };

  const fUnit = (e) => {
    let currentUnitObj = Unit.find((obj) => {
      return obj.Unit === e.target.value;
    });
    if (!!currentUnitObj) {
      setBufferObj((obj) => ({
        ...obj,
        LI_Unit: currentUnitObj.Unit,
        B_UnitName: currentUnitObj.Name1,
        B_PackQty: currentUnitObj.PackQty,
        B_Packing: currentUnitObj.PackDesc,
      }));
    }
  };
  useEffect(() => {
    let vBaseQtyCal =
      fcovertToNumber(sBufferObj.LI_Qty) *
      fcovertToNumber(sBufferObj.B_PackQty);

    setBufferObj((obj) => ({
      ...obj,
      LI_BaseQty: vBaseQtyCal,
    }));
  }, [sBufferObj.LI_Qty, sBufferObj.B_PackQty]);
  return (
    <div style={{ margin: vMediaQuery ? "1px" : "40px" }}>
      <div className="d-flex justify-content-between align-items-center mb-1">
        <BreadCrumbs />
      </div>
      {!vMediaQuery && (
        <Grid container spacing={1} p={1.5}>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container>
              <Grid item xs={4} md={2.8}>
                <Typography variant="subtitle1" component="span">
                  Doc.No
                </Typography>
              </Grid>
              <Grid item xs={0.5} md={1}>
                <Typography variant="subtitle1" component="span">
                  :
                </Typography>
              </Grid>
              <Grid item xs={7.5} md={8.2}>
                <Typography variant="subtitle1" component="span">
                  {" "}
                  {vRdxHead.A_VocNo}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container>
              <Grid item xs={4} md={2.8}>
                <Typography variant="subtitle1" component="span">
                  Status
                </Typography>
              </Grid>
              <Grid item xs={0.5} md={1}>
                <Typography variant="subtitle1" component="span">
                  :
                </Typography>
              </Grid>
              <Grid item xs={7.5} md={8.2}>
                <Typography variant="subtitle1" component="span">
                  {" "}
                  {vRdxItem.Status}
                </Typography>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} sm={6} md={4}>
            <Grid container>
              <Grid item xs={4} md={2.8}>
                <Typography variant="subtitle1" component="span">
                  Loc
                </Typography>
              </Grid>
              <Grid item xs={0.5} md={1}>
                <Typography variant="subtitle1" component="span">
                  :
                </Typography>
              </Grid>
              <Grid item xs={7.5} md={8.2}>
                <Typography variant="subtitle1" component="span">
                  {vRdxItem.LocName}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container>
              <Grid item xs={4} md={2.8}>
                <Typography variant="subtitle1" component="span">
                  BaseQty
                </Typography>
              </Grid>
              <Grid item xs={0.5} md={1}>
                <Typography variant="subtitle1" component="span">
                  :
                </Typography>
              </Grid>
              <Grid item xs={7.5} md={8.2}>
                <Typography variant="subtitle1" component="span">
                  {vRdxItem.TotalBaseQty}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container>
              <Grid item xs={4} md={2.8}>
                <Typography variant="subtitle1" component="span">
                  Seg.Qty
                </Typography>
              </Grid>
              <Grid item xs={0.5} md={1}>
                <Typography variant="subtitle1" component="span">
                  :
                </Typography>
              </Grid>
              <Grid item xs={7.5} md={8.2}>
                <Typography variant="subtitle1" component="span">
                  {vRdxItem.TotalPickedQty}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container>
              <Grid item xs={4} md={2.8}>
                <Typography variant="subtitle1" component="span">
                  BalanceQty
                </Typography>
              </Grid>
              <Grid item xs={0.5} md={1}>
                <Typography variant="subtitle1" component="span">
                  :
                </Typography>
              </Grid>
              <Grid item xs={7.5} md={8.2}>
                <Typography variant="subtitle1" component="span">
                  {vRdxItem.BalanceQty}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container>
              <Grid item xs={4} md={2.8}>
                <Typography variant="subtitle1" component="span">
                  Item.Cd
                </Typography>
              </Grid>
              <Grid item xs={0.5} md={1}>
                <Typography variant="subtitle1" component="span">
                  :
                </Typography>
              </Grid>
              <Grid item xs={7.5} md={8.2}>
                <Typography variant="subtitle1" component="span">
                  {vRdxItem.ItmCd}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} md={4}>
            <Grid container>
              <Grid item xs={4} sm={2} md={2.8}>
                <Typography variant="subtitle1" component="span">
                  Item Name
                </Typography>
              </Grid>
              <Grid item xs={0.5} sx={1} md={1}>
                <Typography variant="subtitle1" component="span">
                  :
                </Typography>
              </Grid>
              <Grid item xs={7.5} sx={9} md={8.2}>
                <Typography variant="subtitle1" component="span">
                  {vRdxItem.ItmName}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={6} md={4}>
            <Grid container>
              {/* <Grid item xs={4} md={2.8}>
              <Typography variant="subtitle1" component="span">
                Slot.Id
              </Typography>
            </Grid>
            <Grid item xs={0.5} md={1}>
              <Typography variant="subtitle1" component="span">
                :
              </Typography>
            </Grid> */}
              <Grid item xs={7.5} md={8.2} component="span">
                <Box
                  sx={{
                    width: 32,
                    height: 32,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "main.primary",
                    fontWeight: "bolder",
                    fontSize: "12px",
                    border: "1px solid blue",
                  }}
                >
                  <Typography variant="body2" fontWeight="bold">
                    {vRdxItem.L_Loc}
                  </Typography>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      )}
       {vMediaQuery &&
       <div
        style={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <Box sx={{ backgroundColor: "#FAF9F6", mb: 1.5 }} >
          {/* Cards for Each Location */}
          <Grid container spacing={2}>
              <Grid item xs={12} sm={6} md={4} lg={3}>
                <Card
                  sx={{
                    width: "100%",
                    borderRadius: 1,
                    // boxShadow: 2,
                    border: "1px solid #FAF9F6",
                    "& .MuiCardContent-root": {
                      padding: "10px !important",
                    },
                  }}
                >
                  <CardContent>
                    <Box sx={{ backgroundColor: "#FAF9F6", p: 1.5 }}>
                      {/* Name and Position */}
                      <Grid container>
                        <Grid item xs={11}>
                          {/* <Typography variant="h6" fontWeight="bold"> */}
                          <Typography variant="span" fontWeight="bold">
                            {vRdxItem.ItmName}  
                          </Typography>
                          <Typography variant="subtitle2" color="gray">
                            {vRdxItem.ItmCd}
                          </Typography>
                        </Grid>
                        <Grid item xs={1} textAlign={"right"}>
                          <Box
                            sx={{
                              width: 32,
                              height: 32,
                              borderRadius: "50%",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              color: "main.primary",
                              fontWeight: "bolder",
                              fontSize: "12px",
                              border: "1px solid blue",
                            }}
                          >
                            <Typography variant="body2" fontWeight="bold">
                              {vRdxItem.L_Loc}
                            </Typography>
                          </Box>
                        </Grid>
                      </Grid>
                    </Box>
                    {/* Quantity Details */}
                    <Box
                      sx={{
                        backgroundColor: "#F4F4F4",
                        borderRadius: 2,
                        p: "10px",
                        mt: 0.5,
                      }}
                    >
                      <Grid container spacing={1} textAlign={"center"}>
                        <Grid item xs={4}>
                          <Typography variant="caption" color="gray">
                          BaseQty
                          </Typography>
                          <Typography variant="subtitle1" fontWeight="bold">
                          {vRdxItem.TotalBaseQty}
                          </Typography>
                        </Grid>
                        <Grid item xs={5}>
                          <Typography variant="caption" color="gray">
                            Seg.Qty
                          </Typography>
                          <Typography variant="subtitle1" fontWeight="bold">
                          {vRdxItem.TotalPickedQty}
                          </Typography>
                        </Grid>
                        <Grid item xs={3}>
                          <Typography variant="caption" color="gray">
                            Balance
                          </Typography>
                          <Typography variant="subtitle1" fontWeight="bold">
                          {vRdxItem.BalanceQty}
                          </Typography>
                        </Grid>
                      </Grid>
                    </Box>
                  </CardContent>
                </Card>
              </Grid>
            </Grid>
        </Box>
      </div>}
      <Grid
        container
        spacing={vMediaQuery ? 0.5 : 2}
        style={{ marginBottom: "10px", alignItems: "end" }}
      >
        {/* <Grid item xs={12} sm={2} md={2} className="lastkeyDetect">
          <CmpTypographyField
            xcomponent={"div"}
            xText={vRdxItem.A_SegregationMethod == 1 ? "Virtual Bin" : "DropId"}
          />
          {vRdxItem.A_SegregationMethod == 1 ? (
            <CmpSelectBox
              xsize="small"
              xLabelText=""
              xValue={sBufferObj.VirtualBin}
              xOnChange={(e) => {
                setBufferObj((obj) => ({
                  ...obj,
                  VirtualBin: e.target.value,
                }));
              }}
              xName={"VirtualBin"}
              xData={VirtualBinList}
              xValueMember={""}
              xDispalyMember={""}
              xError={Error.VirtualBin === "" ? false : true}
              xErrorMessage={Error.VirtualBin}
              xDisable={false}
            />
          ) : (
            <CmpTextFieldEnter
              xSize="small"
              // xSize="small"
              xLabelText={""}
              xVariant={"outlined"}
              xValue={sBufferObj.L_DropID}
              xOnChange={(e) => {
                setBufferObj((obj) => ({
                  ...obj,
                  L_DropID: e.target.value,
                }));
              }}
              xReadOnly={false}
              xType={"text"}
              xName={"Scan"}
              xOnKeyUp={(e) => {
                if (e.key === "Enter" || e._reactName === "onClick") {
                  setTimeout(async () => {
                    document.getElementsByName("LI_Qty")[0]?.focus();
                  }, 100);
                }
              }}
              xOnEnter={(e) => {
                e = { key: "Enter" };
                if (e.key === "Enter" || e._reactName === "onClick") {
                  setTimeout(async () => {
                    document.getElementsByName("LI_Qty")[0]?.focus();
                  }, 100);
                }
              }}
              xSmShow={!!vMediaQuery}
              xError={Error.L_DropID === "" ? false : true}
              xErrorMessage={Error.L_DropID}
            />
          )}
        </Grid> */}
        <Grid item xs={6} sm={2} md={1} lg={1} className="lastkeyDetect">
          <CmpTypographyField xcomponent={"div"} xText={"Qty"} />
          {/* <CmpInputField
            xtabIndex={"108"}
            xValue={sBufferObj.LI_Qty}
            xType={"number"} // text/number/password
            xName={"LI_Qty"}
            xReadOnly={false}
            xOnChange={(e) => {
              setBufferObj((obj) => ({
                ...obj,
                LI_Qty: e.target.value,
              }));
            }}
            xError={Error.LI_Qty === "" ? false : true}
            xErrorMessage={Error.LI_Qty}
            xOnKeyUp={() => {}}
          /> */}
          <CmpTextField
            xsize="small"
            xLabelText={""}
            xVariant={"outlined"}
            xValue={sBufferObj.LI_Qty}
            xOnChange={(e) => {
              setBufferObj((obj) => ({
                ...obj,
                LI_Qty: e.target.value,
              }));
            }}
            xReadOnly={false}
            xType={"number"}
            xName={"LI_Qty"}
            xId={"LI_Qty"}
            xError={Error.LI_Qty === "" ? false : true}
            xErrorMessage={Error.LI_Qty}
          />
        </Grid>
        <Grid item xs={6} sm={2} md={1} lg={1.5} className="lastkeyDetect">
          <CmpTypographyField xcomponent={"div"} xText={"Unit"} />
          {/* <CmpSelectField
            xtabIndex={"109"}
            xLabelText="Unit"
            xValue={sBufferObj.LI_Unit}
            xOnChange={fUnit}
            xName={"LI_Unit"}
            xData={Unit}
            xValueMember={""}
            xDispalyMember={""}
            xError={Error.LI_Unit === "" ? false : true}
            xErrorMessage={Error.LI_Unit}
            xDisable={false}
          /> */}
          <CmpSelectBox
            xsize="small"
            xLabelText=""
            xValue={sBufferObj.LI_Unit}
            xOnChange={fUnit}
            xName={"LI_Unit"}
            xData={Unit}
            xValueMember={""}
            xDispalyMember={""}
            xError={Error.LI_Unit === "" ? false : true}
            xErrorMessage={Error.LI_Unit}
            xDisable={vRdxItem.UnitId != ""}
          />
        </Grid>

        <Grid item xs={"auto"} mb={0.5}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={async () => {
              fNew();
            }}
            size="small"
          >
            New
          </Button>
        </Grid>
        <Grid item xs={"auto"} mb={0.5}>
          <Button
            fullWidth={true}
            variant="contained"
            color="primary"
            disabled={vRdxItem.Status != "ENTER"}
            onClick={async () => {
              await save();
            }}
            size="small"
          >
            Save
          </Button>
        </Grid>
        <Grid item xs={"auto"} mb={0.5}>
          <Button
            fullWidth
            variant="contained"
            disabled={vRdxItem.Status != "ENTER"}
            color="primary"
            onClick={async () => {
              await fDelete();
            }}
            size="small"
          >
            Delete
          </Button>
        </Grid>
      </Grid>

      <Detail
        data={data}
        onClick={(items) => {
          fOnRowClick(items);
        }}
        vMediaQuery={vMediaQuery}
      />
    </div>
  );
};

export default SegregrationDetail;
